import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogGeneralCicStatementEdit } from "@/entities/IProfile";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
export default function ProfileActivityLogGeneralStatement(t0) {
  const $ = _c(4);
  const {
    log
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProfileActivityLogItemAction action="changed" />;
    t2 = <span className="tw-whitespace-nowrap tw-text-sm lg:tw-text-base tw-text-iron-300 tw-font-medium">About</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== log.contents.statement.statement_value) {
    t3 = <div className="tw-flex tw-min-w-0 tw-max-w-full tw-gap-x-1">{t1}{t2}<span className="tw-min-w-0 tw-truncate tw-overflow-hidden tw-text-sm lg:tw-text-base tw-font-medium tw-text-iron-300">{log.contents.statement.statement_value}</span></div>;
    $[2] = log.contents.statement.statement_value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}